<template>
  <div class="footer__top-partners">
    <p>{{ content.description }}</p>
    <MobilePartnersCarousel :content="content" v-if="!mq.mdPlus" />
    <div class="partner__container" v-if="mq.mdPlus">
      <div class="partner__group">
        <PartnerCard
          :content="researcher"
          v-for="(researcher, researcherKey) in content.items.research"
          :key="researcherKey"
        />
      </div>
      <div class="partner__group">
        <PartnerCard
          :content="partner"
          v-for="(partner, partnerKey) in content.items.partner"
          :key="partnerKey"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MobilePartnersCarousel from '@/components/blocks/MobilePartnersCarousel.vue'
import { PartnerCard } from '@/components/cards'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'FooterPartners',
  mixins: [DefaultSectionProps],
  inject: ['mq'],
  components: { MobilePartnersCarousel, PartnerCard },
}
</script>
